import { gql } from '@apollo/client';

export const ADD_UPDATE_INCOME_SOURCE = gql`
  mutation addOrUpdateIncomeSource($input: IncomeSourceItemInput) {
    addOrUpdateIncomeSource(input: $input) {
      commandId
    }
  }
`;

export const ADD_UPDATE_INCOME_SOURCE_DETAIL = gql`
  mutation addOrUpdateIncomeSourceDetail($input: IncomeSourceDetailItemInput) {
    addOrUpdateIncomeSourceDetail(input: $input) {
      commandId
    }
  }
`;

export const DELETE_INCOME_SOURCE_DETAIL = gql`
  mutation deleteIncomeSourceDetail($input: DeleteIncomeSourceDetailInput) {
    deleteIncomeSourceDetail(input: $input) {
      commandId
    }
  }
`;
